import React from 'react'
import Cookies from 'js-cookie'
import AppShellSkeletonFallback from './AppShellSkeletonFallback'

const loginLoading = (
  <div className="pt-3 text-center">
    <div className="sk-spinner sk-spinner-pulse"></div>
  </div>
)

const AppLoadingFallback = () => {
  const token = Cookies.get(`${process.env.REACT_APP_COOKIE_PREFIX}_auth`)
  const hasToken = typeof token === 'string' && token.trim().length > 0

  if (hasToken) {
    return <AppShellSkeletonFallback />
  }

  return loginLoading
}

export default AppLoadingFallback
